module.exports = __webpack_public_path__ + "static/media/fractal.a76e4756.jpg";